const config = {
  vendor: process.env.REACT_APP_VENDOR ?? '',
  LANGUAGES: ['Fr', 'Nl', 'En', 'De'],
  GOOGLE_API_KEY: 'AIzaSyChtuJefd-qQuix57GvrIOFPdbopUWAj9s', // TODO: put this in .env
  options: {
    // address
    adress: {
      useAutoLocation: false,
    },

    // panels
    panels: {
      b2b: [
        {
          id: 'vertex_s',
          type: 1,
          assetIndex: 3,
        },
        {
          id: 'sunpower_p3',
          type: 2,
          assetIndex: 2,
        },
        {
          id: 'sunpower_m3',
          type: 3,
          assetIndex: 1,
        },
      ],
      b2c: [
        {
          id: 'sunpower_m3',
          type: 3,
          assetIndex: 1,
        },
        {
          id: 'sunpower_p3',
          type: 2,
          assetIndex: 2,
        },
        {
          id: 'vertex_s',
          type: 1,
          assetIndex: 3,
        },
      ],
    },

    roofAngles: [
      { key: 'flat', value: 0 },
      { key: '15', value: 15 },
      { key: '30', value: 30 },
      { key: '45', value: 45 },
      // { key: 'other', value: -1 },
    ],
    roofAngleDefault: 45,

    roofTypes: [
      { id: 'tuile', type: 3, filter: 'normal' },
      { id: 'ardoise', type: 2, filter: 'normal' },
      { id: 'metal', type: 4, filter: 'normal' },
      { id: 'roofing', type: 1, filter: 'flat' },
      { id: 'epdm', type: 1, filter: 'flat' },
      { id: 'leadax', type: 1, filter: 'flat' },
    ],

    // consumption
    consumption: {
      b2b: {
        default: 10000,
        min: 100,
        max: 50000,
        maxForLightAnimation: 40000,
        buttonStep: 100,
        sliderStep: 10,
      },
      b2c: {
        default: 4000,
        min: 100,
        max: 20000,
        maxForLightAnimation: 10000,
        buttonStep: 100,
        sliderStep: 10,
      },
    },

    counter: [
      { id: 'mono', type: 1 },
      { id: 'tri', type: 2 },
      { id: 'tri_n', type: 3 },
    ],

    inverters: [
      // { id: 'SMA', type: 1 },
      { id: 'SolarEdge', type: 2 },
    ],

    // bill
    bill: {
      defaultValues: {
        default: 200,
        min: 10,
        max: 1000,
        buttonStep: 100,
        sliderStep: 10,
      },
      b2b: {
        default: 300,
        max: 1600,
      },
      b2c: {},
    },
    // map
    map: {
      tipInterval: 8,
    },
  },
};

export default config;
